// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"795e96155063ac99","9364":"2a230a139594f678"}[chunkId] + ".css";
};